export const DBNIE_RESET_STATE = 'DBNIE_RESET_STATE';
export const DBNIE_CURRENT_ITEM = 'DBNIE_CURRENT_ITEM';

export const DBNIE_REQUEST_LOADING = 'DBNIE_REQUEST_LOADING';
export const DBNIE_REQUEST_SUCCESS = 'DBNIE_REQUEST_SUCCESS';
export const DBNIE_REQUEST_FAILED = 'DBNIE_REQUEST_FAILED';

export const DBNIE_CURRENT_ACTION = 'DBNIE_CURRENT_ACTION';
export const DBNIE_RESET_ACTION = 'DBNIE_RESET_ACTION';